import { PageWrapper } from './PageWrapper';
import { PricingPageRoutes } from './PricingPageRoutes';
import { jsx as _jsx } from "react/jsx-runtime";
export const PricingPageApp = () => {
  return /*#__PURE__*/_jsx(PageWrapper, {
    children: /*#__PURE__*/_jsx(PricingPageRoutes, {})
  });
};